import React, { useEffect, useState } from "react";
import { Card, CardHeader, CardTitle, Row, Col, Alert, Badge, Tooltip } from "reactstrap";
import TMHLoader from "../TMHLoader/TMHLoader"
import useToken from "../../helpers/useToken"
import useTimeZone from "../../helpers/useTimeZone"

export default function SignUpSummary() {
    const [AllData, setAllData] = useState(null)
    const [FMHData, setFMHData] = useState()
    const [FMHmData, setFMHmData] = useState()
    const [isLoading, setIsLoading] = useState(false)
    const [mobileAppData, setMobileAppData] = useState()
    const [FMSData, setFMSData] = useState()
    const [FMSmData, setFMSmData] = useState()
    const [reviewData, setReviewData] = useState()
    const [extInstallData, setExtInstallData] = useState()
    const [extSearchData, setExtSearchData] = useState()
    const [addressData, setAddressData] = useState()
    const [emailsData, setEmailsData] = useState()
    const [IFAsData, setIFAsData] = useState()
    const [emailAndIFAData, setEmailAndIFAData] = useState()
    const [tooltipMobileOpen, setTooltipMobileOpen] = useState(false)
    const [tooltipFMSOpen, setTooltipFMSOpen] = useState(false)
    const [tooltipIFAOpen, setTooltipIFAOpen] = useState(false)

    const { token } = useToken()
    const { timeZone } = useTimeZone()

    useEffect(() => {
        console.log("SignUpSummary::")
        async function initData() {
            console.log('SignUpOverView: update data')
            setIsLoading(true)
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append("Cache-Control", "no-cache");
            myHeaders.append("Access-Token", token);

            var requestOptions = {
                method: 'GET',
                headers: myHeaders,
            }

            var params = new URLSearchParams({
                'timezone_offset_minutes': timeZone * -60
            })

            fetch(process.env.REACT_APP_BASE_URL + "users/signup_summary?" + params, requestOptions)
                .then((response) => {
                    return new Promise((resolve) => response.json()
                        .then((json) => resolve({
                            status: response.status,
                            ok: response.ok,
                            json,
                        })))
                }).then(
                    async (result) => {
                        var json = result.json
                        if (result.ok) {
                            var datasets = json?.data
                            setAllData(datasets["All"])
                            setFMHData(datasets["FreeMovieHouse"])
                            setFMHmData(datasets["Mobile/FreeMovieHouse"])
                            setMobileAppData(datasets["MobileApp"])
                            setFMSData(datasets["FreeMovieSpin"])
                            setFMSmData(datasets["Mobile/FreeMovieSpin"])
                            setReviewData(datasets["AppReviews"])
                            setExtInstallData(datasets["ExtInstall"])
                            setExtSearchData(datasets["ExtSearch"])
                            setAddressData(datasets["Addresses"])
                            setEmailsData(datasets["emails"])
                            setIFAsData(datasets["IFAs"])
                            setEmailAndIFAData(datasets["emailAndIFA"])
                            setIsLoading(false)
                        }
                        else {
                            console.log(result.json.message)
                            setIsLoading(false)
                        }
                    }
                )
        }

        initData()
    }, [token, timeZone])

    return (
        <TMHLoader active={isLoading}>
            <Row>
                <Col sm="6" md="6" lg="2">
                    <Card>
                        <CardHeader>
                            <CardTitle className="text-info" tag="h4">
                                Synced/Signup Summary
                            </CardTitle>
                            <Alert color="warning">
                                <span>
                                    <i className="tim-icons icon-bullet-list-67 text-success" />  Total <Badge color="default" pill>{AllData?.total[0]}/{AllData?.total[1]}</Badge>
                                </span>
                            </Alert>
                            <Alert color="success">
                                <i className="tim-icons icon-bullet-list-67 text-success" />  Today <Badge color="default" pill>{AllData?.today[0]}/{AllData?.today[1]}</Badge>
                            </Alert>
                            <Alert color="danger">
                                <i className="tim-icons icon-bullet-list-67 text-success" />  Yesterday <Badge color="default" pill>{AllData?.yesterday[0]}/{AllData?.yesterday[1]}</Badge>
                            </Alert>
                        </CardHeader>
                    </Card>
                </Col>
                <Col sm="6" md="6" lg="2">
                    <Card>
                        <CardHeader>
                            <CardTitle className="text-info" tag="h4">
                                Free Movie House
                            </CardTitle>
                            <Alert color="warning">
                                <span>
                                    <i className="tim-icons icon-bullet-list-67 text-success" />  Total <Badge color="default" pill>{FMHData?.total[0]}/{FMHData?.total[1]}</Badge>
                                </span>
                            </Alert>
                            <Alert color="success">
                                <i className="tim-icons icon-bullet-list-67 text-success" />  Today <Badge color="default" pill>{FMHData?.today[0]}/{FMHData?.today[1]}</Badge>
                            </Alert>
                            <Alert color="danger">
                                <i className="tim-icons icon-bullet-list-67 text-success" />  Yesterday <Badge color="default" pill>{FMHData?.yesterday[0]}/{FMHData?.yesterday[1]}</Badge>
                            </Alert>
                        </CardHeader>
                    </Card>
                </Col>
                <Col sm="6" md="6" lg="2">
                    <Card>
                        <CardHeader>
                            <CardTitle style={{
                                "cursor": "pointer",
                                textAlign: "center"
                            }} id="mobileAppLabel" className="text-info" tag="h4">
                                Mobile App
                            </CardTitle>
                            <Tooltip isOpen={tooltipMobileOpen}
                                delay={{ show: 0, hide: 0 }}
                                target="mobileAppLabel"
                                placement="bottom"
                                toggle={() => setTooltipMobileOpen(!tooltipMobileOpen)}>
                                MobileIDs / RokuID gained / PINsConfirmed
                            </Tooltip>
                            <Alert color="warning">
                                <span>
                                    <i className="tim-icons icon-bullet-list-67 text-success" />  Total <Badge color="default" pill>{mobileAppData?.total[1]}/{mobileAppData?.total[0]}/{mobileAppData?.total[2]}</Badge>
                                </span>
                            </Alert>
                            <Alert color="success">
                                <i className="tim-icons icon-bullet-list-67 text-success" />  Today <Badge color="default" pill>{mobileAppData?.today[1]}/{mobileAppData?.today[0]}/{mobileAppData?.today[2]}</Badge>
                            </Alert>
                            <Alert color="danger">
                                <i className="tim-icons icon-bullet-list-67 text-success" />  Yesterday <Badge color="default" pill>{mobileAppData?.yesterday[1]}/{mobileAppData?.yesterday[0]}/{mobileAppData?.yesterday[2]}</Badge>
                            </Alert>
                        </CardHeader>
                    </Card>
                </Col>
                <Col sm="6" md="6" lg="2">
                    <Card>
                        <CardHeader>
                            <CardTitle style={{
                                "cursor": "pointer",
                                textAlign: "center"
                            }} id="FMSLabel" className="text-info" tag="h4">
                                Free Movie Spin
                            </CardTitle>
                            <Tooltip isOpen={tooltipFMSOpen}
                                delay={{ show: 0, hide: 0 }}
                                target="FMSLabel"
                                placement="bottom"
                                toggle={() => setTooltipFMSOpen(!tooltipFMSOpen)}>
                                Emails / Passwords created / Proceeded second Spin
                            </Tooltip>
                            <Alert color="warning">
                                <span>
                                    <i className="tim-icons icon-bullet-list-67 text-success" />  Total <Badge color="default" pill>{FMSData?.total[2]}/{FMSData?.total[1]}/{FMSData?.total[0]}</Badge>
                                </span>
                            </Alert>
                            <Alert color="success">
                                <i className="tim-icons icon-bullet-list-67 text-success" />  Today <Badge color="default" pill>{FMSData?.today[2]}/{FMSData?.today[1]}/{FMSData?.today[0]}</Badge>
                            </Alert>
                            <Alert color="danger">
                                <i className="tim-icons icon-bullet-list-67 text-success" />  Yesterday <Badge color="default" pill>{FMSData?.yesterday[2]}/{FMSData?.yesterday[1]}/{FMSData?.yesterday[0]}</Badge>
                            </Alert>
                        </CardHeader>
                    </Card>
                </Col>
                <Col sm="6" md="6" lg="2">
                    <Card>
                        <CardHeader>
                            <CardTitle className="text-info" tag="h4">
                                Mobile / FMH
                            </CardTitle>
                            <Alert color="warning">
                                <span>
                                    <i className="tim-icons icon-bullet-list-67 text-success" />  Total <Badge color="default" pill>{FMHmData?.total[0]}/{FMHmData?.total[1]}</Badge>
                                </span>
                            </Alert>
                            <Alert color="success">
                                <i className="tim-icons icon-bullet-list-67 text-success" />  Today <Badge color="default" pill>{FMHmData?.today[0]}/{FMHmData?.today[1]}</Badge>
                            </Alert>
                            <Alert color="danger">
                                <i className="tim-icons icon-bullet-list-67 text-success" />  Yesterday <Badge color="default" pill>{FMHmData?.yesterday[0]}/{FMHmData?.yesterday[1]}</Badge>
                            </Alert>
                        </CardHeader>
                    </Card>
                </Col>
                <Col sm="6" md="6" lg="2">
                    <Card>
                        <CardHeader>
                            <CardTitle className="text-info" tag="h4">
                                Mobile / Free Movie Spin
                            </CardTitle>
                            <Alert color="warning">
                                <span>
                                    <i className="tim-icons icon-bullet-list-67 text-success" />  Total <Badge color="default" pill>{FMSmData?.total[0]}/{FMSmData?.total[1]}</Badge>
                                </span>
                            </Alert>
                            <Alert color="success">
                                <i className="tim-icons icon-bullet-list-67 text-success" />  Today <Badge color="default" pill>{FMSmData?.today[0]}/{FMSmData?.today[1]}</Badge>
                            </Alert>
                            <Alert color="danger">
                                <i className="tim-icons icon-bullet-list-67 text-success" />  Yesterday <Badge color="default" pill>{FMSmData?.yesterday[0]}/{FMSmData?.yesterday[1]}</Badge>
                            </Alert>
                        </CardHeader>
                    </Card>
                </Col>
                <Col sm="6" md="6" lg="3">
                    <Card>
                        <CardHeader>
                            <CardTitle style={{
                                "cursor": "pointer",
                                textAlign: "center"
                            }} id="IFALabel" className="text-info" tag="h4">
                                IFA & Email
                            </CardTitle>
                            <Tooltip isOpen={tooltipIFAOpen}
                                delay={{ show: 0, hide: 0 }}
                                target="IFALabel"
                                placement="bottom"
                                toggle={() => setTooltipIFAOpen(!tooltipIFAOpen)}>
                                Emails / IFAs / Both
                            </Tooltip>
                            <Alert color="warning">
                                <span>
                                    <i className="tim-icons icon-bullet-list-67 text-success" />  Total <Badge color="default" pill>{emailsData?.total}/{IFAsData?.total}/{emailAndIFAData?.total}</Badge>
                                </span>
                            </Alert>
                            <Alert color="success">
                                <i className="tim-icons icon-bullet-list-67 text-success" />  Today <Badge color="default" pill>{emailsData?.today}/{IFAsData?.today}/{emailAndIFAData?.today}</Badge>
                            </Alert>
                            <Alert color="danger">
                                <i className="tim-icons icon-bullet-list-67 text-success" />  Yesterday <Badge color="default" pill>{emailsData?.yesterday}/{IFAsData?.yesterday}/{emailAndIFAData?.yesterday}</Badge>
                            </Alert>
                        </CardHeader>
                    </Card>
                </Col>
                <Col sm="12" md="12" lg="4">
                    <Card className="card-chart">
                        <CardHeader>
                            <CardTitle className="text-info" tag="h4">
                                <span>
                                    App Reviews
                                </span>
                                <span className="float-right">
                                    Addresses
                                </span>
                            </CardTitle>
                            <Row>
                                <Col sm="6" lg="6">
                                    <Alert color="warning">
                                        <span>
                                            <i className="tim-icons icon-bullet-list-67 text-success" />  Total <Badge color="default" pill>{reviewData?.total}</Badge>
                                        </span>
                                    </Alert>
                                    <Alert color="success">
                                        <i className="tim-icons icon-bullet-list-67 text-success" />  Today <Badge color="default" pill>{reviewData?.today}</Badge>
                                    </Alert>
                                    <Alert color="danger">
                                        <i className="tim-icons icon-bullet-list-67 text-success" />  Yesterday <Badge color="default" pill>{reviewData?.yesterday}</Badge>
                                    </Alert>
                                </Col>
                                <Col sm="6" lg="6">
                                    <Alert color="warning">
                                        <span>
                                            <i className="tim-icons icon-bullet-list-67 text-success" />  Total <Badge color="default" pill>{addressData?.total}</Badge>
                                        </span>
                                    </Alert>
                                    <Alert color="success">
                                        <i className="tim-icons icon-bullet-list-67 text-success" />  Today <Badge color="default" pill>{addressData?.today}</Badge>
                                    </Alert>
                                    <Alert color="danger">
                                        <i className="tim-icons icon-bullet-list-67 text-success" />  Yesterday <Badge color="default" pill>{addressData?.yesterday}</Badge>
                                    </Alert>
                                </Col>
                            </Row>

                        </CardHeader>
                    </Card>
                </Col>
                <Col sm="12" md="12" lg="5">
                    <Card className="card-chart">
                        <CardHeader>
                            <CardTitle className="text-info" tag="h4">
                                <span>
                                    Chrome Ex & Searches
                                </span>
                            </CardTitle>
                            <Row>
                                <Col sm="6" lg="6">
                                    <Alert color="warning">
                                        <span>
                                            <i className="tim-icons icon-bullet-list-67 text-success" />  Total installs <Badge color="default" pill>{extInstallData?.total}</Badge>
                                        </span>
                                    </Alert>
                                    <Alert color="success">
                                        <i className="tim-icons icon-bullet-list-67 text-success" />  Today <Badge color="default" pill>{extInstallData?.today}</Badge>
                                    </Alert>
                                    <Alert color="danger">
                                        <i className="tim-icons icon-bullet-list-67 text-success" />  Yesterday <Badge color="default" pill>{extInstallData?.yesterday}</Badge>
                                    </Alert>
                                </Col>
                                <Col sm="6" lg="6">
                                    <Alert color="warning">
                                        <span>
                                            <i className="tim-icons icon-bullet-list-67 text-success" />  Total Searches <Badge color="default" pill>{extSearchData?.total}</Badge>
                                        </span>
                                    </Alert>
                                    <Alert color="success">
                                        <i className="tim-icons icon-bullet-list-67 text-success" />  Today <Badge color="default" pill>{extSearchData?.today}</Badge>
                                    </Alert>
                                    <Alert color="danger">
                                        <i className="tim-icons icon-bullet-list-67 text-success" />  Yesterday <Badge color="default" pill>{extSearchData?.yesterday}</Badge>
                                    </Alert>
                                </Col>
                            </Row>

                        </CardHeader>
                    </Card>
                </Col>
            </Row>
        </TMHLoader>

    )
}